import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {
  RegistryProvider,
  RegistryStatusResponse,
} from '../../models/registry.model';

@Injectable({
  providedIn: 'root'
})
export class RegistryService {
  private apiService = inject(ApiService);

  getStatus(clientId: string, providers?: RegistryProvider[]): Observable<RegistryStatusResponse> {
    const params = {
      clientId,
      ...(providers?.length ? {providers: providers.join(',')} : {}),
    };
    return this.apiService.get<RegistryStatusResponse>('companies/registry/status', params);
  }
}
